export default __webpack_public_path__ + "images/bathroom-heat-1.eb7e96224d0cd67c5bfb8480388db61f.png";